var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1739_40375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1739_40375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6923 19H8.3077C7.80257 19 7.375 18.825 7.025 18.475C6.675 18.125 6.5 17.6974 6.5 17.1923V3.8077C6.5 3.30257 6.675 2.875 7.025 2.525C7.375 2.175 7.80257 2 8.3077 2H15.25L20.5 7.24995V17.1923C20.5 17.6974 20.325 18.125 19.975 18.475C19.625 18.825 19.1974 19 18.6923 19ZM14.5 7.99995V3.49998H8.3077C8.23077 3.49998 8.16024 3.53203 8.09613 3.59613C8.03203 3.66024 7.99998 3.73077 7.99998 3.8077V17.1923C7.99998 17.2692 8.03203 17.3397 8.09613 17.4038C8.16024 17.4679 8.23077 17.5 8.3077 17.5H18.6923C18.7692 17.5 18.8397 17.4679 18.9038 17.4038C18.9679 17.3397 19 17.2692 19 17.1923V7.99995H14.5ZM4.3077 23C3.80257 23 3.375 22.825 3.025 22.475C2.675 22.125 2.5 21.6974 2.5 21.1923V8H3.99998V21.1923C3.99998 21.2692 4.03202 21.3397 4.09613 21.4038C4.16024 21.4679 4.23077 21.5 4.3077 21.5H14.5V22.9999L4.3077 23Z",
    fill: "#183883"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/file_copy.f3e8c4918a589605c1681c4d1f06de6e.svg";
export { ForwardRef as ReactComponent };